// Axios 配置
import axios from 'axios'

// 配置全局 axios 默认实例
axios.defaults.timeout = 10000

// 响应拦截器：错误处理
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // 错误处理
    if (error.response) {
      // 服务器返回了错误状态码
      console.error('请求错误:', error.response.status, error.response.data)
    } else if (error.request) {
      // 请求已发出但没有收到响应
      console.error('网络错误:', error.request)
    } else {
      // 其他错误
      console.error('错误:', error.message)
    }
    return Promise.reject(error)
  }
)

// 导出配置好的 axios 实例
export default axios

